import { render } from "./FooterVigna.vue?vue&type=template&id=3e060f74"
import script from "./FooterVigna.vue?vue&type=script&lang=js"
export * from "./FooterVigna.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__